var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, { viewBox: '0 0 16 16' }, props), React.createElement('path', {
        d: 'M 2.5,6.458428 6.2900927,2.6683353 c 1.7536248,-1.75362478 4.6103363,-1.75362488 6.3639603,-10e-8 1.760696,1.7606956 1.753625,4.6103359 0,6.3639609 L 8.0720014,13.614349 c -1.1808683,1.180868 -3.0900566,1.180868 -4.2709254,-1e-6 -1.159655,-1.159655 -1.166726,-3.04763 5e-7,-4.2143558 L 8.411413,4.7896557 c 0.5868987,-0.5868987 1.5344219,-0.5868988 2.121321,-1e-7 0.586898,0.5868987 0.586898,1.5344217 0,2.1213204 l -3.7900931,3.790093',
        fill: 'none',
        stroke: '#a5a5a5',
        strokeWidth: '2',
        strokeOpacity: '1',
        strokeDasharray: 'none'
    }), React.createElement('path', {
        d: 'M 1,1 15,15',
        fill: 'none',
        stroke: '#e13208',
        strokeWidth: '2',
        strokeLinecap: 'butt',
        strokeOpacity: '1',
        strokeDasharray: 'none'
    }));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/ClipCrossed.svg
// module id = 519
// module chunks = 1